import React from "react";
import { Link } from 'react-router-dom';
import { Header } from "../../Application/Header";
import { Footer } from "../../Application/Footer";
import paypal from "../../assests/paypal-logo.png";
import southafrica from "../../assests/southafrica.png";
import kenya from "../../assests/kenya-1.jpg";
import india from "../../assests/indiaflag.png";
import indiaqr from "../../assests/IndiaQR.jpeg";
import till from "../../assests/till.jpg";
import COUNTRIES from "../../assests/COUNTRIES.png";
import CAMPS from "../../assests/CAMPS.png";
import USA from "../../assests/us.png";
import USAflag from "../../assests/united-states.png";
import VOLUNTEERS from "../../assests/VOLUNTEERS.png";
import SURGIRIES from "../../assests/SURGIRIES.png";
import { useEffect, useState } from "react";


function Donation() {
  const [surgeriesCounter, setSurgeriesCounter] = useState(0);
  const [campsCounter, setCampsCounter] = useState(0);
  const [countriesCounter, setCountriesCounter] = useState(0);
  const [volunteersCounter, setVolunteersCounter] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [displayCardSection, setDisplayCardSection] = useState(false);
  const [currency, setCurrency] = useState("usd");
  const [otherAmountStatus, setOtherAmountStatus] = useState(false)

  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);

  useEffect(() => {
    // Counter  Starts
    const surgeriesInterval = setInterval(() => {
      if (surgeriesCounter < 992) {
        setSurgeriesCounter(surgeriesCounter + 1);
      } else {
        clearInterval(surgeriesInterval);
      }
    }, -10);

    const campsInterval = setInterval(() => {
      if (campsCounter < 75) {
        setCampsCounter(campsCounter + 1);
      } else {
        clearInterval(campsInterval);
      }
    },);

    const countriesInterval = setInterval(() => {
      if (countriesCounter < 7) {
        setCountriesCounter(countriesCounter + 1);
      } else {
        clearInterval(countriesInterval);
      }
    },);

    const volunteersInterval = setInterval(() => {
      if (volunteersCounter < 600) {
        setVolunteersCounter(volunteersCounter + 1);
      } else {
        clearInterval(volunteersInterval);
      }
    },);

    return () => {
      clearInterval(surgeriesInterval);
      clearInterval(campsInterval);
      clearInterval(countriesInterval);
      clearInterval(volunteersInterval);
    };
  }, [surgeriesCounter, campsCounter, countriesCounter, volunteersCounter]);
  // Counter Ends

  const selectPaymentAmount = (amount) => {
    setPaymentAmount(amount)
  }

  const selectCardDisplaySection = (data) => {
    setDisplayCardSection(data)
  }

  useEffect(() => {
  }, [currency])

  return (

    <>
      <Header />

      <section className="donate" style={{ minHeight: "100vh" }}>
        <div className="container-fluid">
          <div className="row justify-content-end">
            <div className="col-md-5 mt-5 col-sm-12 text-white pt-5">
              <h2 className="fw-bold sedanfont mt-5 display-4">Until the World Is</h2>
              <h3 className="fw-bold text-danger sedanfont display-5 mt-2">Cleft-Free</h3>
              <h5 className="fw-bold mt-3 ">You can Donate for</h5>
              <div className="row">
                <div className="col-md-4 mt-2">
                  <button className="btn btn-outline-light fw-bold  w-75" data-bs-toggle="modal" data-bs-target="#exampleModalusa">USA</button>
                </div>
                <div class="modal fade" id="exampleModalusa" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 className="text-uppercase mx-auto text-dark fw-bold">Love without reason - <span className="text-danger">usa</span></h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div className="row d-flex justify-content-center">
                          <div class="col-md-8 text-center">
                            <div class="card shadow p-4  rounded m-1" style={{ minHeight: "320px" }}>
                              <div class="card-text">
                                <div className="row">
                                  <div className="col-md-12 text-center text-dark mt-1">
                                    <p><b>
                                      Use Link for USA</b>
                                    </p>
                                    <img src={USA} classname="img-fluid p-2 mt-5" width={80} /><br />
                                    <div className="mt-3">
                                      <a href="https://lovewithoutreasonusa.harnessgiving.org/donate/" class="text-danger fw-bold mt-5 text-decoration-none">USA Donation</a>
                                    </div>
                                    <br></br>
                                    <Link to="https://lovewithoutreasonusa.harnessgiving.org/donate/" target="_blank" class="btn btn-danger text-white px-3 mt-3  rounded mt-3">
                                      Donate </Link>
                                  </div>
                                </div>
                              </div>
                              <br></br><br></br>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mt-2">
                  <button className="btn btn-outline-light fw-bold w-75" data-bs-toggle="modal" data-bs-target="#exampleModal3">INDIA</button>
                  <div class="modal fade" id="exampleModalpaypal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 className="text-uppercase mx-auto text-dark fw-bold">donate via - <span className="text-primary">paypal</span></h5>

                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <div className="row d-flex justify-content-center">
                            <div class="col-md-8 col-sm-12 text-center">
                              <div class="card shadow p-4  rounded m-1" style={{ minHeight: "320px" }}>
                                <div class="card-text">
                                  <div className="row">

                                    <div className="col-md-12 text-center mt-3 text-dark">
                                      <p><b>
                                        You may use PayPal if you are donating using non-US
                                        currency.</b>
                                      </p>
                                      <img src={paypal} classname="img-fluid p-2 mt-2 text-center" /><br />
                                      <Link to="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=NJMPFAWUKAHR4&ssrt=1696853675162 " target="_blank" class="btn btn-primary text-white px-3 rounded mt-3">
                                        Donate </Link>
                                    </div>
                                  </div>
                                </div>
                                <br></br><br></br>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 className="text-uppercase mx-auto text-dark fw-bold">Love without reason foundation - <span className="text-danger">india</span></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div className="d-flex justify-content-center">
                          <div class=" col-md-8 ">
                            <div class="card shadow p-2 text-center rounded m-1" style={{ minHeight: "320px" }}>
                              <div class="card-text text-dark">
                                <p><b>Scan QR code for INDIA</b></p>
                              </div>
                              <div class="row d-flex justify-content-center">
                                <div class="col-4 p-1">
                                  <img className="img-fluid" src={india} width={80} />
                                </div>
                              </div>
                              <div class="row d-flex justify-content-center">
                                <div class="col-12 p-3">
                                  <img className="img-fluid" src={indiaqr} width={160} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-3 d-flex justify-content-center">
                <div className="col-md-4 mt-4">
                  <button className="btn btn-outline-light fw-bold w-75" data-bs-toggle="modal" data-bs-target="#exampleModal4">KENYA</button>
                </div>

                <div class="modal fade" id="exampleModal4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 className="text-uppercase mx-auto text-dark fw-bold">Love without reason foundation - <span className="text-danger">kenya</span></h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div className="d-flex justify-content-center">
                          <div className=" col-md-8 col-sm-12 ">
                            <div className="card shadow p-4 text-center rounded m-1" style={{ minHeight: "320px" }}>
                              <div className="card-text text-dark">
                                <p><b>Use TILL Number for KENYA</b></p>
                              </div>
                              <div className="row d-flex justify-content-center">
                                <div className="col-4 p-1">
                                  <img className="img-fluid" src={kenya} width={80} />
                                </div>
                              </div>
                              <div className="row d-flex justify-content-center">
                                <div className="col-12 p-4">
                                  {/* <img className="img-fluid" src={till} width={50} /> */}
                                  <div className="card-text mt-3 text-dark">
                                    <p>

                                      <b> Till Number : 8005594</b>

                                      <br />
                                      <b>Love Without Reason Kenya</b>

                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mt-4">
                  <button className="btn btn-outline-light fw-bold w-75" data-bs-toggle="modal" data-bs-target="#exampleModal5">AFRICA</button>
                </div>
                <div class="modal fade" id="exampleModal5" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 className="text-uppercase mx-auto text-dark fw-bold">Love without reason foundation - <span className="text-danger">south africa</span></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div className="d-flex justify-content-center">
                          <div className=" col-md-8 ">
                            <div className="card shadow text-center rounded p-4 m-1" style={{ minHeight: "320px" }}>
                              <div className="card-text text-dark">
                                <p> <b>Use Bank Details For SOUTH AFRICA</b></p>
                              </div>
                              <div className="row d-flex justify-content-center">
                                <div className="col-4 p-1">
                                  <img className="img-fluid " src={southafrica} width={80} />
                                </div>
                              </div>
                              <div className="card-text mt-5 text-dark" >
                                <p>

                                  Account Name : <b>LOVE WITHOUT REASON NPC</b>

                                  <br />
                                  Branch code : <b>250 655</b>
                                  <br />
                                  Account No : <b>63032305674</b>
                                  <br />

                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className=" mt-2">
                 <h5 className="fw-bold mt-3 ">You can Donate via</h5>
                  <button className="btn btn-outline-light fw-bold px-5" data-bs-toggle="modal" data-bs-target="#exampleModalpaypal">PAYPAL</button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section >



      <section className="bg-dark " style={{ minHeight: "75vh" }}>
        <div className="container-fluid ">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-4 m-4">
              <h1 className=" mt-5 text-warning">
                The Impact Of<br /> Your Donation
              </h1>
              <h4 className="text-white">
                These numbers are not just statistics they represent real
                lives touched, families forever changed,and
                dreams rekindled.Your Support has been instrumental
                in bringing about this transformation.
              </h4>
            </div>
            <div className='col-md-2'>
              <div className="image-container">
                <img src={COUNTRIES} className='img-fluid mt-3' />
                <div className="image-text1">
                  {/* <h1 className='fw-bolder text-white mt-5'> {countriesCounter}</h1> */}
                  <h1 className='fw-bold text-white mt-5'> {countriesCounter}</h1>
                  <h5 className='fw-bolder text-white'>COUNTRIES</h5>
                </div>
              </div>
              <div className="image-container">
                <img src={CAMPS} className='img-fluid mt-2' />
                <div className="image-text1">
                  <h1 className='fw-bolder text-white mt-5'>{campsCounter}</h1>
                  <h5 className='fw-bolder text-white'>CAMPS</h5>
                  {/* <h5 className='font-weight-bold text-white'>CAMPS</h5> */}
                </div>
              </div>
            </div>
            <div className='col-md-2 mb-3' >
              <div className="image-container">
                <img src={VOLUNTEERS} className='img-fluid mt-5 mt-3' />
                <div className="image-text1">
                  <h1 className='fw-bolder text-white mt-5'>{volunteersCounter}</h1>
                  {/* <h1 className='font-weight-bold text-white mt-5'>{volunteersCounter}</h1> */}
                  <h5 className='fw-bolder text-white'>VOLUNTEERS</h5>
                </div>
              </div>
              <div className="image-container">
                <img src={SURGIRIES} className='img-fluid mt-2' />
                <div className="image-text1">
                  <h1 className='fw-bolder text-white  mt-5'>{surgeriesCounter}</h1>
                  <h5 className='fw-bolder text-white'>SURGERIES</h5>
                  {/* <h1 className='font-weight-bold text-white  mt-5'>{surgeriesCounter}</h1>
                  <h5 className='fw-bolderd text-white'>SURGERIES</h5> */}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section style={{ minHeight: '80vh' }}>
        <div className="container mt-1">
          {/* <div className="row row2 d-flex align-items-center p-4 bg-info">
            <div className="col-lg-6 col-md-6 col-sm-12 text-white text-center">
              <h3>Other Ways to Donate</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-white text-center">
              <h4>Check By Mail</h4>
              <p>
                Love Without Reason
                <br />
                P.O. Box 21009 Chattanooga, TN 37424
              </p>
            </div>
          </div> */}

          <div class="row  p-5 d-flex justify-content-center">
            <div class="col-md-4 col-sm-12 text-center">
              <div class="card shadow p-4  rounded m-1" style={{ minHeight: "320px" }}>
                <div class="card-text">
                  <div className="row">

                    <div className="col-md-12 text-center mt-1">
                      <p><b>
                        Use Link for USA</b>
                      </p>



                      <img src={USA} classname="img-fluid p-2 mt-5" width={80} /><br />
                      <div className="mt-3">
                        <a href="https://lovewithoutreasonusa.harnessgiving.org/donate/" class="text-danger fw-bold mt-5 text-decoration-none">USA Donation</a>
                      </div>
                      <br></br>

                      <Link to="https://lovewithoutreasonusa.harnessgiving.org/donate/" target="_blank" class="btn btn-danger text-white px-3 mt-3  rounded mt-3">
                        Donate </Link>

                    </div>
                  </div>

                </div>
                <br></br><br></br>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 text-center">
              <div class="card shadow p-4  rounded m-1" style={{ minHeight: "320px" }}>
                <div class="card-text">
                  <div className="row">

                    <div className="col-md-12 text-center mt-3">
                      <p><b>
                        You may use PayPal if you are donating using non-US
                        currency.</b>
                      </p>
                      <img src={paypal} classname="img-fluid p-2 mt-2 text-center" /><br />
                      <Link to="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=NJMPFAWUKAHR4&ssrt=1696853675162 " target="_blank" class="btn btn-primary text-white px-3 rounded mt-3">
                        Donate </Link>
                    </div>
                  </div>
                </div>
                <br></br><br></br>
              </div>
            </div>



            <div class=" col-md-4 col-sm-12 ">
              <div class="card shadow p-2 text-center rounded m-1" style={{ minHeight: "320px" }}>
                <div class="card-text">
                  <p><b>Scan QR code for INDIA</b></p>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-4 p-1">
                    <img className="img-fluid" src={india} width={80} />
                  </div>
                </div>
                <div class="row d-flex justify-content-center">
                  <div class="col-12 p-3">
                    <img className="img-fluid" src={indiaqr} width={160} />
                  </div>
                </div>
              </div>
            </div>

            <div className=" col-md-6 col-sm-12 ">
              <div className="card shadow p-4 text-center rounded m-1" style={{ minHeight: "320px" }}>
                <div className="card-text">
                  <p><b>Use TILL Number for KENYA</b></p>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-4 p-1">
                    <img className="img-fluid" src={kenya} width={80} />
                  </div>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-12 p-4">
                    {/* <img className="img-fluid" src={till} width={50} /> */}
                    <div className="card-text mt-5">
                      <p>

                        Till Number : <b>8005594</b>

                        <br />
                        <b>Love Without Reason Kenya</b>

                        <br />

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className=" col-md-6 col-sm-12">
              <div className="card shadow text-center rounded p-4 m-1" style={{ minHeight: "320px" }}>
                <div className="card-text">
                  <p> <b>Use Bank Details For SOUTH AFRICA</b></p>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-4 p-1">
                    <img className="img-fluid " src={southafrica} width={80} />
                  </div>
                </div>
                <div className="card-text mt-5">
                  <p>

                    Account Name : <b>LOVE WITHOUT REASON NPC</b>

                    <br />
                    Branch code : <b>250 655</b>
                    <br />
                    Account No : <b>63032305674</b>
                    <br />

                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
    </>
  );
}

export { Donation };
